import React, { Component } from 'react'
import ConferenceBtnGroup from '../../components/ConferenceBtnGroup/ConferenceBtnGroup'
import ConferenceContent from './ConferenceContent'
import CreateConference from './CreateConference'
import AddAttendess from './AddAttendess'
import { connect } from 'react-redux'
import './Main.css'
import { get, post, postFile } from '../../service/index'
import swal from 'sweetalert'
import Loader from '../../components/Loader/Loader'

class Main extends Component {

  constructor(props) {
    super(props)

    this.state = {
      current: 0,
      createCF: 0,

      // conference data
      conferenceData: [],


      // create conference
      title: '',
      detail: '',
      meeting_time: '',

      // create sub conference
      sub_conference: [],

      // add attendess
      all_department: [],
      selected_department: 0,
      meeting_attendess: [], // left
      selected_array: [], // right

      conference_id: '',
      btnLoading: false,
      loading: true
    }
  }

  componentWillMount = () => {
    const { isLogin } = this.props.login
    if (!isLogin) {
      this.props.history.push('/login')
    }
  }

  componentDidMount = async () => {
    try {
      // this.props.loading(true)
      const { token, name, lastname: last_name, user_id: id } = this.props.login.user
      const data = await get('/get_conference', token)
      const dd = await get('/department', token)

      this.setState({
        conferenceData: data.result,
        all_department: [{ value: -1, label: '---เลือกทั้งหมด---' },
        ...dd.result.map(el => ({ value: el.id, label: el.department_name }))],
        meeting_attendess: [{
          name,
          last_name,
          id
        }],
        loading: false

      })

      // this.props.loading(false)
    } catch (err) {
      console.log(err)
      // this.props.loading(false)
    }
  }

  render() {
    const { current, createCF, conferenceData, meeting_attendess, all_department, selected_department, selected_array } = this.state
    const { title, detail, sub_conference } = this.state
    const { token } = this.props.login.user
    // create conference
    const createLeftProps = {
      title,
      onChageTitle: this._onChange,
      detail,
      onChageDetail: this._onChange
    }

    const createRightProps = {
      sub_conference,
      handleAddSub: this._handleAddSub,
      handleRemoveSub: this._handleRemoveSub,
      btnLoading: this.state.btnLoading

    }

    // add attendess
    const attendessLeftProps = {
      title,
      meeting_attendess,
      deleteAll: this._DeleteAll

    }

    const attendessRightProps = {
      all_department,
      selected_department,
      onSelect: this._onSelect,
      selected_array,
      onAdd: this._onAdd,
      onDelete: this._onDelete,
      selectAll: this._SelectAll

    }

    return (

      <div className='home-container'>
        <div className="banner">
          <img
            src={require('../../assets/image/logo_home.png')}
            alt="epam-icon"
          />
          <p>Electronic Provincial Administration Meeting</p>
          {/* conference btn group */}
          {
            this.props.login.user.role ? this.props.login.user.role.toLowerCase().includes('admin') ? <ConferenceBtnGroup current={current} handleCurrent={this._handleChange('current')} /> : null : null
          }

        </div>
        {
          this.state.loading ? <Loader /> :
            current === 0 ?
              <ConferenceContent
                setResult={result => this.setState({ conferenceData: result })}
                data={conferenceData}
                onClick={this._handleOnPress}
              /> :
              (createCF === 0 ?
                <CreateConference
                  {...createLeftProps} {...createRightProps}
                  goNext={this._handleNext(1)}
                  token={token}
                /> :

                <AddAttendess
                  goBack={this._handleNext(0)}
                  {...attendessLeftProps}
                  {...attendessRightProps}
                  onCreateConference={this._onCreateConference}
                />)
        }
      </div>
    )
  }

  // handle next

  _handleNext = (value) => () => {
    const { title, detail, sub_conference } = this.state
    if (title && detail && sub_conference.length > 0) {
      this.setState({ createCF: value })
    } else {
      swal('กรุณาตรวจสอบข้อมูล', 'หัวข้อการประชุม รายละเอียดการประชุม วาระการประชุม', 'warning')
    }
  }

  _handleChange = key =>
    value => () => {
      if (this.state.current === 1 && value === 0) {
        swal('โปรดทราบ', 'คุณต้องการยกเลิกการสร้างการประชุมใช่หรือไม่', 'warning', {
          buttons: true,

        }).then(willCancel => {
          if (willCancel) {
            this.resetState()
            this.setState({ [key]: value })
          }
        })

      } else {
        this.setState({ [key]: value })
      }

    }

  _onChange = e => this.setState({ [e.target.name]: e.target.value })

  // open conference detail
  _handleOnPress = (id) => () => {
    const conferenceData = this.state.conferenceData.find(el => el.conference_id === id)
    this.props.history.push({ pathname: '/conference/' + id, state: conferenceData })
  }

  // add sub conference
  // ### fix for upload file per click
  _handleAddSub = async (title, meeting_time, pdf) => {
    // token
    const { token } = this.props.login.user
    const {
      sub_conference,
      conference_id,
      title: conferenceTitle,
      detail,
      meeting_attendess,
    } = this.state
    console.log(conference_id)
    // console.log('sub_conference', sub_conference);
    this.setState({ btnLoading: true })
    try {
      if (conference_id == '') {
        const addUserConference = meeting_attendess.map(el => el.id)
        const createConference = await post('/create_conference', {
          title: conferenceTitle,
          detail,
          meeting_time,
        }, token)
        const { conference_id: cf_id } = createConference

        const form = new FormData()
        form.append('title', title)
        form.append('conference_id', cf_id)
        form.append('meeting_time', meeting_time)
        form.append('pdf', pdf)
        form.append('position', 1)
        const addSubConference = await postFile('/create_sub_conference', form, token)
        const addAttendess = await post('/add_user_conference', {
          user: addUserConference, conference_id: cf_id
        }, token)

        this.setState(prevState => ({
          conference_id: cf_id,
          sub_conference: [...prevState.sub_conference, {
            title,
            conference_id: '',
            meeting_time,
            pdf,
            sub_id: addSubConference.sub_id,
            position: 1,
          }],
          btnLoading: false
        }))
      } else {

        const form = new FormData()
        form.append('title', title)
        form.append('conference_id', conference_id)
        form.append('meeting_time', meeting_time)
        form.append('pdf', pdf)
        form.append('position', 1 + sub_conference.length)
        const addSubConference = await postFile('/create_sub_conference', form, token)
        console.log(addSubConference)
        this.setState(prevState => ({
          sub_conference: [...prevState.sub_conference, {
            title,
            conference_id: '',
            meeting_time,
            pdf,
            sub_id: addSubConference.sub_id,
            position: 1 + sub_conference.length,
          }],
          btnLoading: false
        }))
      }

    } catch (error) {
      console.log(error)
      swal('เกิดปัญหาในการเพิ่มเอกสาร', 'กรุณาตรวจสอบเอกสารของท่าน', 'warning')
    }


  }

  _handleRemoveSub = (index) => async () => {
    try {
      const { token } = this.props.login.user
      const { conference_id, sub_conference } = this.state
      const sub_conference_id = sub_conference[index].sub_id
      await post('/delete_sub_conference', { conference_id, sub_conference_id }, token)
      // console.log('conference', sub_conference)
      // console.log('sub_conference_id', sub_conference_id)
      this.setState(prevState => ({
        sub_conference: [
          ...prevState.sub_conference.slice(0, index),
          ...prevState.sub_conference.slice(index + 1)]
      }))



    } catch (error) {
      swal('ลบไฟล์ผิดพลาด', '', 'error')
    }

  }

  // selece department
  _onSelect = async (value) => {
    const { token } = this.props.login.user
    const { meeting_attendess } = this.state
    this.setState({ selected_department: value })
    if (value) {
      try {
        const getDepartment = await post('/person_department', { department_id: value.value }, token)
        const { result } = getDepartment
        // check previous arr
        const selecetdResult = result.map(el => {
          const selected = meeting_attendess.some(ev => ev.id === el.id)
          return { ...el, selected }
        })
        this.setState({ selected_array: selecetdResult })
      } catch (err) {
        swal('การรับหน่วยงานผิดพลาด กรุณาลองใหม่ในภายหลัง', '', 'error')
      }
    } else {
      this.setState({ selected_array: [] })
    }

  }

  // add attendance
  _onAdd = (userObj, index) =>
    () => {

      this.setState(prevState => ({
        meeting_attendess: [...prevState.meeting_attendess, userObj],
        selected_array: [...prevState.selected_array.slice(0, index),
        { ...prevState.selected_array[index], selected: true },
        ...prevState.selected_array.slice(index + 1),
        ]
      }))

    }

  _onDelete = (id) => () => {
    const { user_id } = this.props.login.user
    if (user_id === id) {
      swal('ไม่สามารถลบผู้สร้างการประชุมได้', '', 'warning')
    } else {
      this.setState(prevState => {
        const meeting_id = prevState.meeting_attendess.findIndex(el => el.id == id)
        const seleted_id = prevState.selected_array.findIndex(el => el.id == id)

        return ({
          meeting_attendess: meeting_id >= 0 ? [...prevState.meeting_attendess.slice(0, meeting_id), ...prevState.meeting_attendess.slice(meeting_id + 1)] : prevState.meeting_attendess,
          selected_array: seleted_id >= 0 ? [...prevState.selected_array.slice(0, seleted_id), { ...prevState.selected_array[seleted_id], selected: false }, ...prevState.selected_array.slice(seleted_id + 1)] : prevState.selected_array
        })

      })
    }

  }

  // attendance
  _SelectAll = () => {
    this.setState(prevState => ({
      meeting_attendess: [...prevState.meeting_attendess, ...prevState.selected_array.reduce((acc, cv) => {

        if (!prevState.meeting_attendess.some(el => el.id === cv.id)) {
          return [...acc, cv]
        } else {
          return acc
        }
      }, [])],
      selected_array: prevState.selected_array.map(el => ({ ...el, selected: true }))
    }))

  }

  // attendance
  _DeleteAll = () => {
    this.setState(prevState => ({
      meeting_attendess: [],
      selected_array: prevState.selected_array.map(el => ({ ...el, selected: false }))
    }))

  }

  // create conference
  _onCreateConference = async () => {
    // this.props.loading(true)
    console.log('try to create')
    this.setState({ loading: true })
    // token
    const { token } = this.props.login.user
    // state
    const {
      title,
      detail,
      sub_conference,
      meeting_attendess,
      conference_id
    } = this.state

    // service
    // const createConferenceObj = {
    //   title,
    //   detail,
    //   meeting_time: sub_conference[0].meeting_time
    // }

    const addUserConference = meeting_attendess.map(el => el.id)

    try {
      // create conf
      // const createConference = await post('/create_conference', createConferenceObj, token)
      // const { conference_id } = createConference

      // add attendess
      const addAttendess = await post('/add_user_conference', {
        user: addUserConference, conference_id
      }, token)

      // add sub
      // sub_conference.forEach(async (el, i) => {
      //   try {
      //     const form = new FormData()
      //     form.append('title', el.title)
      //     form.append('conference_id', conference_id)
      //     form.append('meeting_time', el.meeting_time)
      //     form.append('pdf', el.pdf)
      //     const addSubConference = await postFile('/create_sub_conference', form, token)
      //     if (i == sub_conference.length - 1) {
      //       swal('สร้างการประชุมสำเร็จ', '', 'success').then(success => {

      //         // this.props.loading(false)
      //         this.resetState()
      //       })
      //     }
      //   } catch (err) {
      //     console.log('error from sub conference')
      //     console.log(err)
      //     // this.props.loading(false)
      //   }
      // })

      swal('สร้างการประชุมสำเร็จ', '', 'success').then(success => {

        // this.props.loading(false)
        this.resetState()
      })

    } catch (err) {
      console.log(err)
      // this.props.loading(false)
    }
  }


  resetState = () => this.setState({
    current: 0,
    createCF: 0,
    title: '',
    detail: '',
    meeting_time: '',

    // create sub conference
    sub_conference: [],

    // add attendesserror from sub conference

    all_department: [],
    selected_department: 0,
    meeting_attendess: [], // left
    selected_array: [], // right
    conference_id: '',
    loading: false

  })

}

const mapStateToProps = (state) => ({
  login: state.login
})


// export default Loading(connect(mapStateToProps)(Main))

export default connect(mapStateToProps)(Main)


// WEBPACK FOOTER //
// ./src/pages/Main/Main.js